var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left flex fd"},_vm._l((_vm.menu),function(i,j){return _c('div',{key:j,staticClass:"menulist flex ac",staticStyle:{"cursor":"pointer"},style:({
      backgroundImage:
        i.status == 1
          ? 'url(' + require('../../assets/image/menu1.png') + ')'
          : i.status == 2
          ? 'url(' + require('../../assets/image/menu3.png') + ')'
          : 'url(' + require('../../assets/image/menu2.png') + ')',
      width: i.status == 2 ? '11.93vw' : '10.89vw',
    }),on:{"mouseover":function($event){return _vm.menuover(j)},"mouseleave":function($event){return _vm.menuleave(j)},"click":function($event){return _vm.menuclick(j)}}},[_c('img',{staticStyle:{"margin-left":"10%"},attrs:{"src":i.status == 1 ? i.icon : i.checkicon,"alt":""}}),_c('div',[_c('p',{staticStyle:{"font-size":"0.83vw","color":"white"}},[_vm._v(_vm._s(i.zh))]),_c('p',{staticStyle:{"font-size":"0.52vw","color":"white"}},[_vm._v(_vm._s(i.eng))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }